import { render, staticRenderFns } from "./valueItem.vue?vue&type=template&id=2d6f3e6a&"
import script from "./valueItem.vue?vue&type=script&lang=js&"
export * from "./valueItem.vue?vue&type=script&lang=js&"
import style0 from "./valueItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports